<template>
  <Dialog :visible="true" modal :style="{ width: '42rem' }" :breakpoints="{ '640px': '95vw' }" header="تعديل Footer" @update:visible="$emit('close')">
    <div class="ds-field-grid">
      <div class="form-field">
        <label class="field-label">الاسم</label>
        <input type="text" class="form-control" v-model="form.name_line" />
      </div>
      <div class="form-field">
        <label class="field-label">الوظيفة</label>
        <input type="text" class="form-control" v-model="form.title_line" />
      </div>
    </div>

    <div class="form-field mt-3">
      <label class="field-label">روابط الفوتر</label>
      <div v-for="(link, i) in form.legal_links" :key="i" class="hb-repeat-row">
        <input type="text" class="form-control" v-model="link.label" placeholder="النص" />
        <input type="text" class="form-control" dir="ltr" v-model="link.link" placeholder="/about" />
        <button class="icon-action-btn icon-action-btn--danger" @click="form.legal_links.splice(i, 1)"><i class="pi pi-trash"></i></button>
      </div>
      <button class="ds-btn ds-btn--outline ds-btn--sm mt-1" @click="form.legal_links.push({ label: '', link: '' })">
        <i class="pi pi-plus"></i> إضافة رابط
      </button>
    </div>

    <div class="form-field mt-3">
      <label class="field-label">حسابات التواصل الاجتماعي</label>
      <div v-for="(item, i) in form.socials" :key="i" class="hb-social-row">
        <select class="form-select hb-col-md" v-model="item.icon">
          <option value="facebook">Facebook</option>
          <option value="whatsapp">WhatsApp</option>
          <option value="phone">Phone</option>
        </select>
        <input type="text" class="form-control" dir="ltr" v-model="item.url" placeholder="https://..." />
        <button class="icon-action-btn icon-action-btn--danger" @click="form.socials.splice(i, 1)"><i class="pi pi-trash"></i></button>
      </div>
      <button class="ds-btn ds-btn--outline ds-btn--sm mt-1" @click="form.socials.push({ icon: 'facebook', url: '' })">
        <i class="pi pi-plus"></i> إضافة حساب
      </button>
    </div>

    <div class="form-field mt-3">
      <label class="field-label">نص الحقوق</label>
      <input type="text" class="form-control" v-model="form.credit_text" />
    </div>

    <div class="form-field mt-3 hb-visibility">
      <label class="field-label">إخفاء الفوتر من كل صفحات الموقع</label>
      <InputSwitch :model-value="!form.is_active" @update:model-value="form.is_active = !$event" />
    </div>

    <template #footer>
      <button class="btn-cancel" @click="$emit('close')">إلغاء</button>
      <button class="ds-btn ds-btn--primary" :disabled="store.saving" @click="save">
        <i class="pi pi-check"></i> {{ store.saving ? 'جارٍ الحفظ...' : 'حفظ' }}
      </button>
    </template>
  </Dialog>
</template>

<script>
import Dialog from 'primevue/dialog';
import InputSwitch from 'primevue/inputswitch';
import Swal from 'sweetalert2';
import { useHomepageSectionStore } from '@/stores/useHomepageSectionStore.js';

export default {
  name: 'FooterEditor',
  components: { Dialog, InputSwitch },
  props: { section: { type: Object, required: true } },
  emits: ['close', 'saved'],
  data() {
    const s = this.section.settings || {};
    return {
      form: {
        name_line: s.name_line || '',
        title_line: s.title_line || '',
        legal_links: (s.legal_links || []).map((l) => ({ label: l.label || '', link: l.link || '' })),
        socials: (s.socials || []).map((sc) => ({ icon: sc.icon || 'facebook', url: sc.url || '' })),
        credit_text: s.credit_text || '',
        is_active: !!this.section.is_active,
      },
    };
  },
  computed: {
    store() { return useHomepageSectionStore(); },
  },
  methods: {
    async save() {
      try {
        await this.store.updateSection(this.section.id, {
          settings: {
            name_line: this.form.name_line, title_line: this.form.title_line,
            legal_links: this.form.legal_links, socials: this.form.socials,
            credit_text: this.form.credit_text,
          },
          is_active: this.form.is_active,
        });
        Swal.fire({ icon: 'success', title: 'تم الحفظ', timer: 1400, showConfirmButton: false });
        this.$emit('saved');
      } catch (e) {
        Swal.fire({ icon: 'error', title: e?.response?.data?.message || 'حدث خطأ', timer: 2500, showConfirmButton: false });
      }
    },
  },
};
</script>

<style scoped>
.hb-visibility { display: flex; align-items: center; justify-content: space-between; }
.hb-repeat-row { display: flex; gap: 0.5rem; margin-bottom: 0.5rem; }
.hb-social-row { display: flex; gap: 0.5rem; margin-bottom: 0.5rem; }
.hb-col-md { max-width: 140px; flex-shrink: 0; }
</style>
